import React from 'react';
import LOOKUP from 'constants/lookup';
import { Col } from 'react-bootstrap';
// Basic Components
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';

const SearchFilterBulkTransfer = (props) => {
    let allstatus = [
        { text: "All", value: "All" },
        { text: "Pending", value: 1 },
        { text: "Completed", value: 2 },
        { text: "Need to Receive", value: 3 }
    ]
    return (
        <div>
            <div className="row m-0">
                {/*Search Inputs*/}
                <div className="row m-0">
                    <div className="col col-sm-3">
                        <DatePickerInput
                            name={props.pageName + "CreatedDateStart"}
                            className="search-field"
                            floatingLabelText={"Created Date Start"}
                            hintText={"Created Date Start"}
                        />
                    </div>
                    <div className="col col-sm-3">
                        <DatePickerInput
                            name={props.pageName + "CreatedDateEnd"}
                            className="search-field"
                            floatingLabelText={"Created Date End"}
                            hintText={"Created Date End"}
                        />
                    </div>
                    <div className="col col-sm-3">
                        <DatePickerInput
                            name={props.pageName + "CompletedDateStart"}
                            className="search-field"
                            floatingLabelText={"Completed Date Start"}
                            hintText={"Completed Date Start"}
                        />
                    </div>
                    <div className="col col-sm-3">
                        <DatePickerInput
                            name={props.pageName + "CompletedDateEnd"}
                            className="search-field"
                            floatingLabelText={"Completed Date End"}
                            hintText={"Completed Date End"}
                        />
                    </div>
                    <div className="col col-sm-3">
                        <SelectInput
                            name={`${props.pageName}FromWarehouse`}
                            className="search-field"
                            label="Branch From"
                            floatingLabelText="Branch From"
                            defaultValue="All"
                            options={props.allBranchesFrom}
                        />
                    </div>
                    <div className="col col-sm-3">
                        <SelectInput
                            name={`${props.pageName}ToWarehouse`}
                            className="search-field"
                            label="Branch To"
                            floatingLabelText="Branch To"
                            defaultValue="All"
                            options={props.allBranchesTo} />
                    </div>
                    <div className="col col-sm-3">
                        <SelectInput
                            name={`${props.pageName}TransferStatus`}
                            className="search-field"
                            label="Status"
                            floatingLabelText="Status"
                            defaultValue="All"
                            options={allstatus} />
                    </div>
                </div>

                <div className="row m-0 mt-2 search-buttons">
                    <Col lg={12} xs={12} className='d-flex justify-content-end' >
                        <Button
                            type="IconSearchButton"
                            mini={true}
                            label={LOOKUP.employee.filters.filterButton}
                            onTouchTap={props.search}
                        /></Col>
                </div>
            </div>
        </div>
    );
};


export default SearchFilterBulkTransfer;